/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Condition } from './Condition';
import {
    ConditionFromJSON,
    ConditionFromJSONTyped,
    ConditionToJSON,
    ConditionToJSONTyped,
} from './Condition';

/**
 * One rule of a configured action: a condition plus the bundle to use when it matches.
 * @export
 * @interface ActionRule
 */
export interface ActionRule {
    /**
     * 
     * @type {string}
     * @memberof ActionRule
     */
    readonly id: string;
    /**
     * Position of the rule in the action, used for ordering.
     * @type {number}
     * @memberof ActionRule
     */
    position?: number;
    /**
     * Parameters passed to the action when this rule matches.
     * @type {any}
     * @memberof ActionRule
     */
    extraParams?: any | null;
    /**
     * 
     * @type {Condition}
     * @memberof ActionRule
     */
    readonly condition: Condition | null;
}

/**
 * Check if a given object implements the ActionRule interface.
 */
export function instanceOfActionRule(value: object): value is ActionRule {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('condition' in value) || value['condition'] === undefined) return false;
    return true;
}

export function ActionRuleFromJSON(json: any): ActionRule {
    return ActionRuleFromJSONTyped(json, false);
}

export function ActionRuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionRule {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'position': json['position'] == null ? undefined : json['position'],
        'extraParams': json['extra_params'] === undefined ? undefined : json['extra_params'] === null ? null : json['extra_params'],
        'condition': ConditionFromJSON(json['condition']),
    };
}

export function ActionRuleToJSON(json: any): ActionRule {
    return ActionRuleToJSONTyped(json, false);
}

export function ActionRuleToJSONTyped(value?: Omit<ActionRule, 'id'|'condition'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'extra_params': value['extraParams'],
    };
}

